import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: { email: null, metadata: null },
    selectedAgs: null,
    selectedUpdate: null,
    selectedYearIndex: 0,
    updates: [],
    ags: [],
    pointLayerTypes: [],
    tileLayerTypes: [],
    heatMapLayerTypes: [],
    geoInputTypes: [],
    snackbar: { text: '', type: '', timeout: '' }
  },
  getters,
  mutations,
  actions
});
